import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Info = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99883 2C4.68577 2 2 4.68577 2 7.99883C2 11.3119 4.68577 13.9977 7.99883 13.9977C11.3119 13.9977 13.9977 11.3119 13.9977 7.99883C13.9977 4.68577 11.3119 2 7.99883 2ZM1 7.99883C1 4.13348 4.13348 1 7.99883 1C11.8642 1 14.9977 4.13348 14.9977 7.99883C14.9977 11.8642 11.8642 14.9977 7.99883 14.9977C4.13348 14.9977 1 11.8642 1 7.99883ZM6.24998 7C6.24998 6.72386 6.47384 6.5 6.74998 6.5H7.99812C8.27426 6.5 8.49812 6.72386 8.49812 7V10.5H9.49998C9.77612 10.5 9.99998 10.7239 9.99998 11C9.99998 11.2761 9.77612 11.5 9.49998 11.5H7.99812H6.49998C6.22384 11.5 5.99998 11.2761 5.99998 11C5.99998 10.7239 6.22384 10.5 6.49998 10.5H7.49812V7.5H6.74998C6.47384 7.5 6.24998 7.27614 6.24998 7ZM7.83996 5.72131C8.30385 5.72131 8.67991 5.34525 8.67991 4.88136C8.67991 4.41746 8.30385 4.0414 7.83996 4.0414C7.37606 4.0414 7 4.41746 7 4.88136C7 5.34525 7.37606 5.72131 7.83996 5.72131Z"
      />
    </svg>
  )
})

export default Info
